<template>
  <div class="button-shuffle" @click="shuffle">
    クイズをシャッフルする
  </div>
</template>

<script>
export default {
  methods: {
    shuffle: function () {
      if (window.confirm('クイズをランダムに入れ替えます。')) {
        this.$store.dispatch('quiz/shuffleQuiz', this.$route.params.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button-shuffle {
  @include button-ol-warning;
}
</style>
